module.exports = __webpack_public_path__ + "static/bibinkan-kakanin-40df9daf37f865394eb90943028c4514.jpg";